import { Component, EventEmitter, Inject, Injector, Input, OnInit, Optional, Output, Self, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SvcTestIdDirective } from 'projects/lib-shared-common/src/public-api';
import { SvcControl } from '../svc-control';

@Component({
  selector: 'svc-text',
  templateUrl: './svc-text.component.html',
  styleUrls: ['./svc-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SvcTextComponent),
      multi: true,
    },
  ],
})
export class SvcTextComponent extends SvcControl implements OnInit {
  @Input() label: string | { text: string; icon: string };
  @Input() isObscure: boolean = false;
  @Input() type: string = this.isObscure ? 'password' : 'text';
  @Input() icon: string;
  @Input() readonly: boolean = false;
  @Input() showValidation: boolean = true;
  /** Additive, defaults to current behavior (no marker shown). Set true to render a red "*" after
   *  the label — see RCA Type Registration. */
  @Input() required: boolean = false;
  /** Additive, defaults to current behavior (marker follows `required`). Set false to keep the
   *  required validation but hide the red "*" after the label — see CIL Plan Setup. */
  @Input() showRequiredMarker: boolean = true;
  @Input() placeholder: string;
  @Input() inputId: string;
  @Input() maxLength: string | number;
  @Input() autocomplete = 'on';
  @Input() mask: string;
  @Input() info: string;
  @Input() fallbackTextValue: string;
  @Input() dropSpecialCharacters: boolean;
  @Input() tooltip: string;

  @Output() ngModelChange = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter<void>();

  constructor(
    @Inject(Injector) injector: Injector,
    @Optional() @Self() private readonly _svcTestId?: SvcTestIdDirective
  ) {
    super(injector);
    if (this._svcTestId) this._svcTestId.useOnHost = false;
  }

  public get inputTestId(): string | null {
    return this._svcTestId?.normalizedTestId || null;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected onValueChanged(value): void {
    this.ngModelChange.emit(value);
  }
}
